import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla')({
  beforeLoad: () => getTitleContextSlice('Severity SLA'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
